/**
 * Wrapper component to handle the Jornaya form input fields
 * that use Formik and Reactstrap.
 */
import { useField } from "formik";
import { useEffect, useRef, useState } from "react";
import { Input } from "reactstrap";

const { REACT_APP_JORNAYA_APP_ID } = process.env;

/**
 * Formik Jornaya Input field.
 */
const JornayaInput = ({ jornayaToken, ...other }) => {
  const jornayaSetRef = useRef(null);
  const [jornayaLoaded, setJornayaLoaded] = useState(false);
  const [field, meta, helpers] = useField(other);
  const invalid = Boolean(meta.touched && meta.error);

  useEffect(() => {
    if (jornayaToken && !jornayaLoaded) {
      const parentScript = document.getElementsByTagName("script")[0];
      const jornayaPromise = new Promise((resolve, reject) => {
        let jornayaScript = document.getElementById("LeadiDscript_campaign");
        if (!jornayaScript) {
          jornayaScript = document.createElement("script");
          jornayaScript.id = "LeadiDscript_campaign";
          jornayaScript.type = "text/javascript";
          jornayaScript.async = true;
          jornayaScript.src = `//create.lidstatic.com/campaign/${REACT_APP_JORNAYA_APP_ID}.js?snippet_version=2`;

          jornayaScript.onload = () => {
            resolve(true);
          };

          jornayaScript.onerror = () => {
            resolve(false);
          };

          parentScript.parentNode.insertBefore(jornayaScript, parentScript);
        } else {
          resolve(true);
        }
      });

      jornayaPromise
        .then(() => {
          setJornayaLoaded(true);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [jornayaToken, jornayaLoaded]);

  useEffect(() => {
    if (jornayaToken && jornayaLoaded && !jornayaSetRef.current) {
      jornayaSetRef.current = true;
      helpers.setValue(jornayaToken);
    }
  }, [jornayaToken, jornayaLoaded, helpers]);

  return (
    <Input
      {...field}
      {...other}
      type="hidden"
      value={field.value || ""}
      invalid={invalid}
    />
  );
};

export default JornayaInput;
